import React, { useState, useCallback, useMemo } from 'react';
import { TDropdownButton, TActionList } from './dropdown-button.type';
import { Col } from 'components/layout/layout';
import LabelWrapper from 'components/label-wrapper';
import Select from 'components/form/select';
import { ELabelPos } from 'components/form/formik/types';
import Button from '../button/button';
import { EButtonType, EButtonSize } from '../button/button.types';

const DropdownButton: React.FC<TDropdownButton> = ({
    label,
    actionList,
    disabled,
}) => {
    const labelName = label || '';
    const [selectedAction, setSelectedAction] = useState<string>('');

    const availableActionList: TActionList[] | [] = useMemo(
        () =>
            actionList && Array.isArray(actionList)
                ? actionList.filter(({ isShow }) => isShow)
                : [],
        [actionList],
    );
    const handleClick = useCallback(() => {
        selectedAction &&
            availableActionList[parseInt(selectedAction)].callback();
    }, [availableActionList, selectedAction]);

    const selectOptions = availableActionList.map(({ name }, index) => ({
        key: index.toString(),
        value: name,
    }));
    selectOptions.unshift({ key: '', value: 'Please Select an Action' });

    return (
        <>
            <Col align={'bottom'}>
                <LabelWrapper label={labelName} labelPos={ELabelPos.left}>
                    <Select
                        options={selectOptions}
                        value={selectedAction}
                        disabled={availableActionList.length === 0 || disabled}
                        onChange={(e: any) => {
                            setSelectedAction(e.target.value);
                        }}
                    />
                </LabelWrapper>
                <LabelWrapper>
                    <Button
                        disabled={selectedAction === ''}
                        onClick={handleClick}
                        styleType={EButtonType.Outline}
                        color={'primary'}
                        size={EButtonSize.Small}
                    >
                        OK
                    </Button>
                </LabelWrapper>
            </Col>
        </>
    );
};

export default DropdownButton;
